import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpInterceptor, HttpClient, HttpEvent, HttpHandler, HttpRequest, HttpHeaders } from '@angular/common/http';
import { PlatformLocation, APP_BASE_HREF } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LayoutModule } from './layout/layout.module';
import { Constants } from './app.constants';
import { DialogService } from './shared/services/dialog.service';
import { DownloadComponent } from './shared/components/download/download.component';
import { AddCsrfHeaderInterceptorService } from './shared/services/csrf-header-interceptor.service';
import { AppStoreModule } from './store/app-store.module';
import { Observable } from 'rxjs';
import { MatRippleModule } from '@angular/material/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ExploreModule } from './modules/explore/explore.module';

export function getBaseHref(platformLocation: PlatformLocation): string {
    return platformLocation.getBaseHrefFromDOM();
}

@NgModule({
    declarations: [AppComponent, DownloadComponent],
    imports: [
        BrowserModule,
        RouterModule.forRoot([]),
        HttpClientModule,
        AppRoutingModule,
        FlexLayoutModule,
        LayoutModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
        }),
        AppStoreModule,
        MatRippleModule,
        BrowserAnimationsModule,
        MatIconModule,
        MatButtonModule,
        ExploreModule //fix
    ],
    providers: [
        Constants,
        {
            provide: APP_BASE_HREF,
            useFactory: getBaseHref,
            deps: [PlatformLocation],
        },
        DialogService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AddCsrfHeaderInterceptorService,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: class implements HttpInterceptor {
                intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
                    // if request to getsampledata, then add cache control header
                    if (req.url.indexOf('getsampledata') > -1) {
                        const options = {
                            headers: new HttpHeaders({
                                'Cache-Control': 'no-cache',
                                Pragma: 'no-cache',
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                            }),
                            cache: false,
                        } as any;
                        return next.handle(req.clone(options));
                    } else {
                        return next.handle(req);
                    }
                }
            },
            multi: true,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
